import {Link} from 'shared/pretty-easy-navigation/models';
import {NavigationContext} from '../navigation.context';

export const AutonomyUsageLessonsLink = (context: NavigationContext): Link => ({
    type: 'link',
    label: 'navigation.autonomy_usage_lessons',
    link: '/lessons/list/search',
    queryParams: {
        usage: context.usages.autonomyId,
    },
    icon: 'navigation-link__autonomy-usage-lessons',
});